import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {User} from "../model/user";
import {NotificationSettings} from "../model/notificationSettings";
import {PasswordResetDTO} from "../model/passwordResetDTO";

@Injectable()
export class UserServiceService {

  private usersUrl: string;


  constructor(private http: HttpClient) {
    this.usersUrl = "/api/user";
  }

  public getUser(): Observable<User> {
    console.log("Fetching user")
    return this.http.get<User>(this.usersUrl);
  }

  public getUserById(userId: string): Observable<User> {
    return this.http.get<User>( `/api/users/${userId}`);
  }

  public getUserByMail(user: User): Observable<User> {
    return this.http.post<User>(this.usersUrl + "-by-mail", user);
  }

  /**
   * Retrieves a list of all Users within the given companyLogin
   * @param loginId The users companyLoginId to fetch the list of users for
   */
  public getUserFromLoginId(loginId: String): Observable<User[]> {
    return this.http.get<User[]>(`/api/users/${loginId}/available-users`, {headers: new HttpHeaders({'showing-spinner': ''})});
  }

  public save(user: User) {
    return this.http.post<User>(this.usersUrl, user);
  }

  public saveWithInvitation(user: User, token: string) {
    return this.http.post<User>('/api/userinvite/' + token, user);
  }

  public updatePassword(userid: string, oldPassword: string, password: string) {
    const formData: FormData = new FormData();

    formData.append('oldpassword', oldPassword);
    formData.append('password', password);
    const req = new HttpRequest('PUT', this.usersUrl + "/" + userid + "/attributes/password", formData, {
      reportProgress: true,
      responseType: 'json',
      withCredentials: true
    });
    return this.http.request(req);
  }

  public updateNotificationSettings(userid: string, notificationSettings: NotificationSettings) {
    const formData: FormData = new FormData();

    formData.append("notificationsettings", JSON.stringify(notificationSettings));

    const req = new HttpRequest('PUT', this.usersUrl + "/" + userid + "/attributes/notificationSettings", formData, {
      reportProgress: true,
      responseType: 'json',
      withCredentials: true
    });

    return this.http.request(req);
  }

  public sendResetPasswordMail(mail: string) {
    return this.http.get("/api/sendResetPasswordMail?mail=" + mail);
  }

  public resetPassword(passwordResetDTO: PasswordResetDTO) {
    return this.http.post<User>("/api/resetPassword", passwordResetDTO);
  }

}
